import { CourseTopic } from "../../../recommendation_industry_view/data/response/Course_Topic_Response";

// src/store/GlobalStore.ts
class RecommendationJozunaViewInstance {
  private static instance: RecommendationJozunaViewInstance;
  selectedItem: CourseTopic | null = null;
  openedIndex: number | null = null;

  private constructor() {}

  public static getInstance(): RecommendationJozunaViewInstance {
    if (!RecommendationJozunaViewInstance.instance) {
      RecommendationJozunaViewInstance.instance =
        new RecommendationJozunaViewInstance();
    }
    return RecommendationJozunaViewInstance.instance;
  }

  // Setter methods to update state
  setSelectedItem(item: CourseTopic | null) {
    this.selectedItem = item;
  }

  // Getter methods to retrieve state
  getSelectedItem() {
    return this.selectedItem;
  }
  // Setter methods to update state
  setOpenedIndex(num: number | null) {
    this.openedIndex = num;
  }

  // Getter methods to retrieve state
  getOpenedIndex() {
    return this.openedIndex;
  }
  clearState() {
    this.selectedItem = null; // Resetting the state to initial values
    this.openedIndex = null;
  }
}

export const recommendationJozunaViewInstance_Store =
  RecommendationJozunaViewInstance.getInstance();
